import React from 'react'
import './Policy.css'; // Import CSS file for styling
export const Policy = () => {
  return (
    <div className="policy-container">
      <h1>NFT Marketplace Policy</h1>
      <h2>1. NFT Minting:</h2>
      <p>
        Users are allowed to mint their own NFTs on our platform. The content of the NFT should adhere to our content guidelines, including copyright laws, and should not violate any intellectual property rights. Once you submit your NFT for minting, it will undergo an approval process by our administrators. Approval may take some time, and we reserve the right to reject any NFT that violates our guidelines. If your NFT is rejected, the minting fee will not be refunded. The following NFTs are not allowed on our platform:
      </p>
      <ul>
        <li>Inappropriate Content</li>
        <li>Poor Quality</li>
        <li>Abusive</li>
        <li>Hurting any religion or community</li>
        <li>Unauthorized or Stolen Content</li>
        <li>Violation of Intellectual Property Rights</li>
        <li>Scams or Fraudulent Activity</li>
        <li>Offensive or Hate Speech</li>
        <li>Counterfeit or Replica NFTs</li>
        <li>Prohibited Activities or Illegal Content</li>
        <li>Spam or Misleading Content</li>
      </ul>
      <h2>2. Gas Price:</h2>
      <p>
        Gas fees are required to complete transactions on the blockchain. These fees are determined by the Ethereum network and can vary depending on network congestion. Users are responsible for paying the gas fees associated with their transactions. We recommend checking the current gas prices on the Ethereum network before initiating any transactions. Please note that we are not responsible for any fluctuations in gas prices or delays caused by network congestion.
      </p>
      <h2>3. Listing Price and Refunds:</h2>
      <p>
        Users can list their approved NFTs for sale on our marketplace. The listing price for each NFT is set by the seller and should be reasonable. Once a buyer purchases an NFT, the transaction is considered final and irreversible. We do not offer refunds on completed purchases. It is the seller's responsibility to accurately represent their NFTs, including providing accurate descriptions and any relevant information.
      </p>
      <h2>4. Buying and Reselling NFTs:</h2>
      <p>
        Users can browse and purchase NFTs listed on our marketplace. The buying and selling of NFTs is subject to the terms and conditions agreed upon by the buyer and seller. We do not take responsibility for any disputes or issues that may arise between buyers and sellers. It is recommended to communicate and resolve any conflicts directly. Users are allowed to resell NFTs they have purchased on our platform. However, please ensure that you have the necessary rights and permissions to resell the NFT.
      </p>
      <p className="note">
        <strong>Note:</strong> These policies are subject to change without prior notice. It is your responsibility to stay updated with the latest policies when using our marketplace.
      </p>
      <p className="contact-info">
        If you have any questions or concerns regarding our policies, please contact our support team at <a href="mailto:kashif@technicalpioneers.com">kashif@technicalpioneers.com</a> or visit our Help Center for more information.
      </p>
      <p className="last-updated">Last updated: 26 May, 2023</p>
      <p className="acknowledge">
        By using our NFT Marketplace, you acknowledge that you have read, understood, and agreed to these policies.
      </p>
    </div>
  );

}
